import React, { useState, useEffect } from 'react';
import '../styles/SlotMachine.css';

const SlotMachine = ({ items, onComplete, isVisible = false }) => {
  const [spinning, setSpinning] = useState(false);
  const [currentItems, setCurrentItems] = useState([]);
  const [finalItem, setFinalItem] = useState(null);
  const [animationStep, setAnimationStep] = useState(0);

  useEffect(() => {
    if (isVisible && items && items.length > 0) {
      startAnimation();
    }
  }, [isVisible, items]);

  const startAnimation = () => {
    setSpinning(true);
    setAnimationStep(0);
    
    // Generate random items for animation
    const animationItems = [];
    for (let i = 0; i < 20; i++) {
      animationItems.push(items[Math.floor(Math.random() * items.length)]);
    }
    setCurrentItems(animationItems);

    // Animation sequence
    setTimeout(() => {
      setAnimationStep(1); // Start spinning
      
      setTimeout(() => {
        setAnimationStep(2); // Slow down
        
        setTimeout(() => {
          setAnimationStep(3); // Stop and reveal
          setSpinning(false);
          
          // Show final result after a short delay
          setTimeout(() => {
            setFinalItem(items[0]); // The actual won item
            setTimeout(() => {
              onComplete();
            }, 2000);
          }, 500);
        }, 1500);
      }, 2000);
    }, 500);
  };

  const getRarityColor = (rarity) => {
    const colors = {
      common: '#8B9DC3',
      uncommon: '#5CB85C',
      rare: '#5BC0DE',
      epic: '#9B59B6',
      legendary: '#F39C12'
    };
    return colors[rarity] || colors.common;
  };

  if (!isVisible) return null;

  return (
    <div className="slot-machine-overlay">
      <div className="slot-machine-container">
        <h2 className="slot-title">🎰 Opening Mystery Box...</h2>
        
        <div className="slot-machine">
          <div className="slot-window">
            <div className={`slot-reel ${spinning ? 'spinning' : ''} step-${animationStep}`}>
              {currentItems.map((item, index) => (
                <div 
                  key={index} 
                  className="slot-item"
                  style={{ 
                    borderColor: getRarityColor(item.rarity),
                    backgroundColor: `${getRarityColor(item.rarity)}20`
                  }}
                >
                  {item.imageUrl ? (
                    <img src={item.imageUrl} alt={item.name} />
                  ) : (
                    <div className="item-placeholder">
                      <span className="item-emoji">💎</span>
                    </div>
                  )}
                  <span className="item-name">{item.name}</span>
                  <span className="item-rarity">{item.rarity}</span>
                </div>
              ))}
            </div>
            
            <div className="slot-indicator">
              <div className="indicator-arrow">▼</div>
            </div>
          </div>
        </div>

        {finalItem && (
          <div className="final-result">
            <div className="result-container">
              <h3>🎉 Congratulations!</h3>
              <div 
                className="won-item"
                style={{ 
                  borderColor: getRarityColor(finalItem.rarity),
                  backgroundColor: `${getRarityColor(finalItem.rarity)}30`
                }}
              >
                {finalItem.imageUrl ? (
                  <img src={finalItem.imageUrl} alt={finalItem.name} />
                ) : (
                  <div className="item-placeholder">
                    <span className="item-emoji">💎</span>
                  </div>
                )}
                <h4>{finalItem.name}</h4>
                <p className="item-rarity-text">{finalItem.rarity.toUpperCase()}</p>
                <p className="item-value">Value: ${parseFloat(finalItem.value).toFixed(2)}</p>
                {finalItem.description && (
                  <p className="item-description">{finalItem.description}</p>
                )}
              </div>
            </div>
          </div>
        )}

        <div className="animation-effects">
          <div className="sparkles">
            {[...Array(6)].map((_, i) => (
              <div key={i} className={`sparkle sparkle-${i + 1}`}>✨</div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SlotMachine;
